export const GET_USERID = "GET_USERID";
export const SET_LOCATION = "SET_LOCATION";
export const CHANGE_LAYERS = "CHANGE_LAYERS";
export const CHANGE_BASE_LAYERS = "CHANGE_BASE_LAYERS";
export const TURN_OFF_ALL_LAYERS = "TURN_OFF_ALL_LAYERS";
export const SET_FILTER_ACTIVE = "SET_FILTER_ACTIVE";
export const SET_MAP_OPENED = "SET_MAP_OPENED";
export const SET_DRAW_ENABLED = "SET_DRAW_ENABLED";
export const SET_CONTACT_OPENED = "SET_CONTACT_OPENED";
export const SET_OBJECT_CLICK = "SET_OBJECT_CLICK";




